<template>
  <div>
    <FeedbackListItem
      v-for="item in feedbackItems"
      :key="item.id"
      :item="item"
      :highlight="todo_entry_id === item.id"
    />
  </div>
</template>

<script>
import { sortByAttr } from "../../common/utils";
import FeedbackListItem from "./FeedbackListItem";

export default {
  name: "FeedbackList",
  components: {
    FeedbackListItem
  },
  props: ["objectid"],
  created: async function() {
    this.$store.dispatch("loadFeedbackByObject", {
      objectname: this.$route.name.toLowerCase(),
      id: this.objectid
    });
  },
  computed: {
    feedbackItems: function() {
      let feedback_items = this.$store.state.backend_data.todolist
        .filter(item => item.object === this.objectid)
        .map(item => ({
          ...item,
          created_timestamp: new Date(item.created),
          is_finished: !!item.finished, // we cast item.finished to a bool
          created_string: this.formatDate(item.created),
          finished_string: item.finished
            ? this.formatDate(item.finished)
            : null,
          deadline_string: item.deadline ? this.formatDate(item.deadline) : null
        }));
      feedback_items = sortByAttr(feedback_items, [
        { key: "is_finished", order: "ascending" },
        { key: "created_timestamp", order: "descending" }
      ]);

      return feedback_items;
    },
    todo_entry_id: function() {
      // When the page is opened with the intention to go to this specific todo
      // item, we get the todo_entry_id
      return this.$route.hash.substr(1);
    }
  },
  methods: {
    formatDate: function(date) {
      return new Date(date).toLocaleString("nl-NL", {
        timeZone: "CET",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>

<style></style>
